/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { LoadingSection } from '@coursera/cds-core';

/**
 * @deprecated enterprise-ui use CDS LoadingSection instead
 */
export const LoadingState: React.FC<{ children?: React.ReactNode }> = ({ children, ...props }) => (
  <LoadingSection label={children as unknown as string} {...props} />
);
